import React, { useEffect, useState, useContext, useRef, useMemo } from 'react';
import axios from 'axios';
import { GlobalContext } from '../utils/GlobalContext';
import { isDiamondPriceHidden } from '../utils/helpers';
import { CONSTANT } from '../utils/constants';
import '../../css/GenericBuilder/DiamondPage.css';
import DpSlider from './components/DpSlider';
import { DiamondDetailsModal } from '../Modal/DiamondDetailsModal';
import SpinnerComponent  from '../utils/SpinnerComponent';

const DiamondListPage = ({ account, criteria, totalDiamondsFound, handlePagesChanges, colorCodes, openTab = null }) => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [shape, setShape] = useState('Round');
    const { category, flags, esterllaFlag} = useContext(GlobalContext);
    const [shapeList, setShapeList] = useState([]); // updated to array
    const [clarity, setClarity] = useState([ 'IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2', 'I1', 'I2', 'I3']);
    const [carat, setCarat] = useState('1.00');

    const [clarityIndex, setClarityIndex] = useState([0, 9]);
    const [caratIndex, setCaratIndex] = useState(2);

    const [diamondType, setDiamondType] = useState('all');
    const [search, setSearch] = useState('');
    const [totalFound, setTotalFound] = useState(totalDiamondsFound);
    const [criteriaText, setCriteriaText] = useState(criteria);
    
    /*table formate in the json*/
    const [diamonds, setDiamonds] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true); // To stop when no more data
    const [isFetching, setIsFetching] = useState(false); // Prevent double calls
    /*table formate in the json*/

    // const Range = Slider.Range;
    const colorLabels = ['D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M'];
    const clarityLabels = ['IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2', 'I1', 'I2', 'I3'];
    
    const marks = useMemo(() => {
        if (account === 'W284') {
            return ['0.50','0.75','1.00','1.25','1.50','1.75','2.00','2.50','3.00','3.50','4.00','5.00','6.00','7.00','8.00'];
        }
        return ['0.50','0.75','1.00','1.25','1.50','1.75','2.00','3.00'];
    }, [account]);

    const [colorRangeIndex, setColorRangeIndex] = useState([0, colorLabels.length - 1]);
    const [colorRange, setColorRange] = useState([`D`, `M`]);
    const colorMarks = colorLabels.reduce((acc, label, idx) => {
        acc[idx] = label;
        return acc;
    }, {});

    const clarityMarks = clarityLabels.reduce((acc, label, idx) => {
        acc[idx] = label;
        return acc;
    }, {});

    const [showModal, setShowModal] = useState(false);
    const [selectedStock, setSelectedStock] = useState(null);
    const [selectedStockPrice, setSelectedStockPrice] = useState(null);
    const [imagesList,setImagesList] = useState();
    const [currentImage, setCurrentImage] = useState();
    const [limit, setLimit] = useState(10);
    const [viewMore, setViewMore] = useState(false);

    // Sentinel placed at the end of the diamond list. We observe it with an
    // IntersectionObserver instead of measuring window.scrollY against
    // document.body.offsetHeight, so pagination triggers when the END OF THE
    // LIST enters view — correctly whether this builder is the whole page
    // (standalone) or embedded inside a larger page with content below it.
    const loadMoreRef = useRef(null);

    const handleViewMore = () => {
        if (!isFetching && hasMore) {
            const nextPage = page + 1;
            const newLimit = viewMore ? 10 : 20; // If showing more, use 20, else use 10
            setPage(nextPage);
            setLimit(newLimit);
            setViewMore(!viewMore);
            fetchDiamonds(nextPage, newLimit); // Use newLimit directly, not state
        }else{
            setPage(1);
            setLimit(10);
            setViewMore(false);
            fetchDiamonds(1, 10); // Use newLimit directly, not state
        }
    }

    const handleStockClick = (stock) => {
        if(stock?.Lab == 'gcal'){

        }else{
            if(stock?.cert_link != "" && stock?.image_link != "" && stock?.video_link != ""){
                let list_image = [];
                if(stock?.cert_link != ""){
                    list_image.push({'name':stock?.cert_link,'icon':CONSTANT.BASE_URL+'/assets/images/report.png'});
                }
                if(stock?.image_link != ""){
                    list_image.push({'name':stock?.image_link,'icon':CONSTANT.BASE_URL+'/assets/images/diamond.png'});
                }
                if(stock?.video_link != ""){
                    list_image.push({'name':stock?.video_link,'icon':CONSTANT.BASE_URL+'/assets/images/video-diamond.png'});
                }
                setImagesList(list_image);
                setCurrentImage(stock?.cert_link)
            }
        }
        setSelectedStockPrice(stock.prices.replace(/[$, ]/g, ""));
        setSelectedStock(stock);
        setShowModal(true);
    };

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { updateLayerParams, client_code } = useContext(GlobalContext);
    

    const fetchDiamonds = async (pageToFetch = 1, currentLimit = limit) => {
        if (isFetching) return;
        console.log("Account Number:",account);
        setIsFetching(true);
        try {
            const response = await axios.post(`${CONSTANT.BASE_URL}api/Builder/all-diamonds`, {
                request_type: 'ajax',
                carat_size: carat,
                colorRange,
                clarity,
                shape,
                search_diamond: search,
                natural_lab_filter: diamondType,
                account,
                page: pageToFetch, // 👈 Add this
                limit: currentLimit
            });

            const newDiamonds = response.data.data || [];

            // Append on scroll (page > 1)
            if (pageToFetch > 1) {
                setDiamonds(prev => [...prev, ...newDiamonds]);
            } else {
                setDiamonds(newDiamonds);
            }

            setTotalFound(response.data.total_diamonds_found);
            setHasMore(newDiamonds.length > 0); // No more data if empty
        } catch (err) {
            console.error('Error fetching diamonds', err);
        } finally {
            setIsFetching(false);
        }
    };


    const getShapeDetails = async () => {
        setLoading(true);
        setError(null);
        const baseUrl = `${CONSTANT.BASE_URL}api/Builder/get-shape`;
        try {
            const response = await axios.post(baseUrl, { client_code });
            setShapeList(response.data);
        } catch (error) {
            console.error('Error fetching shape details:', error);
            setError('Failed to load shapes. Please try again later.');
        } finally {
            setLoading(false);
        }
    };
    // Ring Builder's diamond page only filters by shape/carat/color/clarity today
    // (no cut or price_range control exists here), so only those are reported.
    const pushFilterChangeEvent = (overrides = {}) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'ring_builder_filter_change',
            shape: overrides.shape ?? shape,
            carat: overrides.carat ?? carat,
            color: overrides.color ?? colorRange,
            clarity: overrides.clarity ?? clarity,
            customer_number: client_code,
            retailer_domain: window.location.hostname,
        });
    };

    const handleShapeChange = (value) => {
        setShape(value);
        pushFilterChangeEvent({ shape: value });
    };

    const handleChange = (value) => {
        setCaratIndex(value);
        setCarat(marks[value]);
        updateLayerParams('DiamondPageList','carat',marks[value]);
        pushFilterChangeEvent({ carat: marks[value] });
    }
    const handleChangeClarity = (value) => {
        setClarityIndex(value);
        const updatedClarity = clarityLabels.slice(value[0], value[1] + 1);
        setClarity(updatedClarity);
        updateLayerParams('DiamondPageList','clarity',value);
        pushFilterChangeEvent({ clarity: updatedClarity });
    }
    const handleColorRangeChange = (range) => {
        setColorRangeIndex(range);
        const updatedColorRange = [
            colorLabels[range[0]],
            colorLabels[range[1]],
        ];
        setColorRange(updatedColorRange);
        updateLayerParams('DiamondPageList','color',updatedColorRange);
        pushFilterChangeEvent({ color: updatedColorRange });
    };

    const handleSearch = () =>{
        setPage(1);
        setHasMore(true);
        setLimit(10);
        setViewMore(false);
        fetchDiamonds(1, 10); // reset on filter change
    }

    const handleReset = () =>{
        setDiamondType('all');
        setSearch('');
        setColorRange([`D`, `M`]);
        setShape(`Round`);
        setClarity(['IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2', 'I1', 'I2', 'I3']);
        setClarityIndex([0, 9]);
        setCarat(`0.50`);
        setCaratIndex(0);

        setPage(1);
        setHasMore(true);
        setLimit(10);
        setViewMore(false);
        fetchDiamonds(1, 10); // reset on filter change
    }

    useEffect(() => {
        setDiamonds([]);
        setPage(1);
        setHasMore(true);
        setLimit(10);
        setViewMore(false);
        fetchDiamonds(1, 10); // reset on filter change
    }, [clarity, shape, diamondType, search, colorRange, carat]);

    const pushDiamondSelectedEvent = (diamond) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'ring_builder_diamond_selected',
            diamond_id: diamond?.stock_num,
            shape: diamond?.shape,
            carat: diamond?.carat,
            color: diamond?.color,
            clarity: diamond?.clarity,
            price: parseFloat(String(diamond?.prices).replace(/[$, ]/g, '')),
            customer_number: client_code,
            retailer_domain: window.location.hostname,
        });
    }

    const handleAddDiamond = () => {
        pushDiamondSelectedEvent(selectedStock);
        updateLayerParams('Diamond Details','diamond_details',selectedStock);
        updateLayerParams('Diamond Details','diamond_prices',selectedStock?.prices);
        handlePagesChanges('Main');
    }

    const handleCloseDiamondModal = () => {
        setShowModal(false);
    }

    useEffect(() => {
        const el = loadMoreRef.current;
        if (!el) return;

        const io = new IntersectionObserver((entries) => {
            const visible = entries[0]?.isIntersecting;
            if (visible && (criteriaText !== 'CardOption' || viewMore) && !isFetching && hasMore) {
                const nextPage = page + 1;
                setPage(nextPage);
                fetchDiamonds(nextPage, limit);
            }
        }, {
            root: null,            // viewport — works for window scroll AND any scrollable ancestor div
            rootMargin: '300px',   // start loading ~300px before the sentinel is fully in view
            threshold: 0,
        });

        io.observe(el);
        return () => io.disconnect();
    }, [page, isFetching, viewMore, hasMore, limit, criteriaText]);

    useEffect(() => {
        getShapeDetails();
    }, []);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleItemSelect = (d) => {
        pushDiamondSelectedEvent(d);
        updateLayerParams('Diamond Details','diamond_details',d);
        updateLayerParams('Diamond Details','diamond_prices',d?.prices);
        handlePagesChanges('Main');
    }

    return (
        <section className="content mt-20 diamond-list-page">
            <div className="filter_section">
                <div className="row">
                    <div className="col-sm-12 col-xl-5">
                        <h6>Shape:</h6>
                        <ul id="listaShapes">
                            {shapeList.length > 0 ? (
                                shapeList.map((s, i) => (
                                    <li key={s.name || i} className={shape === s.name ? 'active' : ''}>
                                        <a href="#" onClick={(e) => { e.preventDefault(); handleShapeChange(s.name); }}>
                                            <img src={`${CONSTANT.BASE_URL}images/hologram-shape/${s.name}-1.png`} alt={s.name} />
                                            <p className='shape_name'>{s.name}</p>
                                        </a>
                                    </li>
                                ))
                            ) : (
                                <p>Loading shapes...</p>
                            )}
                        </ul>
                    </div>
                    <div className="col-sm-12 col-xl-7">
                        <div className="col-sm-12 col-xl-12 carat">
                            {marks.length > 0 && (
                                <div className="carat-slider-container">
                                    <label className="slider-label">Carat:</label>
                                    {windowWidth <= 950 ? (
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '8px' }}>
                                            {marks.map((m, idx) => (
                                                <button
                                                    key={m}
                                                    type="button"
                                                    onClick={() => handleChange(idx)}
                                                    style={{
                                                        padding: '6px 14px',
                                                        border: caratIndex === idx ? `2px solid ${colorCodes[0]}` : '1px solid #ccc',
                                                        borderRadius: '4px',
                                                        background: 'white',
                                                        color: '#333',
                                                        cursor: 'pointer',
                                                        fontSize: '13px',
                                                        fontWeight: caratIndex === idx ? 'bold' : 'normal',
                                                    }}
                                                >
                                                    {m} ct
                                                </button>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className="slider-wrapper">
                                            <DpSlider min={0} max={marks.length - 1} step={1} value={caratIndex} onChange={handleChange} marks={marks} neutralTrack ariaLabel="Carat" />
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                        <div className="col-sm-12 col-xl-12 color">
                            <label className="slider-label">Color:</label>
                            <DpSlider range min={0} max={colorLabels.length - 1} step={1} value={colorRangeIndex} onChange={handleColorRangeChange} marks={colorMarks} allowCross={false} ariaLabel="Color" />
                        </div>
                        <div className="col-sm-12 col-xl-12 clarity">
                            <div className="carat-slider-container">
                                <label className="slider-label">Clarity:</label>
                                <div className="slider-wrapper">
                                    <DpSlider range min={0} max={clarityLabels.length - 1} step={1} value={clarityIndex} onChange={handleChangeClarity} marks={clarityMarks} allowCross={false} ariaLabel="Clarity" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-35">
                </div>
                <div className="row mt-35">
                    <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                        <h5>
                            <b>Criteria: </b> {shape} | {carat} Ct | {colorRange[0]}-{colorRange[1]} | {clarity[0]}-{clarity[clarity.length - 1]} | Total Diamonds: {totalFound}
                        </h5>
                    </div>
                    <div className="col-12 col-sm-2 col-md-2 col-lg-2">
                        <select className="form-control" value={diamondType} onChange={e => setDiamondType(e.target.value)}>
                            <option value="all">All (Lab/Natural)</option>
                            <option value="Natural">Natural</option>
                            <option value="Lab-Grown">Lab-Grown</option>
                        </select>
                    </div>
                    <div className="col-12 col-sm-2 col-md-2 col-lg-2">
                        <input className="form-control" type="text" placeholder="Search Item Code or Certificate" value={search} onChange={e => setSearch(e.target.value)} />
                    </div>
                    <div  className="col-12 col-sm-2 col-md-2 col-lg-2">
                        <button className='btn btn-primary dp-btn-spacing' onClick={handleSearch}>Search</button>
                        <button className='btn btn-primary dp-btn-spacing' onClick={handleReset}>Reset</button>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12 col-md-12 col-sm-12 col-lg-12'>
                        <div className="diamond-table mt-4">
                            {criteriaText == 'CardOption' ? (
                                <div className='row'>
                                    {diamonds.length > 0 &&  (
                                        <>
                                        {diamonds.map((d, index) => (
                                            <div className='col-12 col-sm-4 col-md-4 col-lg-4'>
                                                <div key={d.id} className={`item-card dp-card-margin`}>
                                                    <button className="item-card-add-btn" title="Select this diamond" onClick={() => handleItemSelect(d)}>+</button>
                                                    <div className='row'>
                                                        <div className='col-6 col-sm-6 col-md-6 col-lg-6 text-center'>
                                                            <input type="radio" name="Item_id" value={d.id} className="Item-radio" id={`Item-${d.id}`} hidden />
                                                            <label htmlFor={`Item-${d.id}`} className="item-label">
                                                                {d.video_link != null &&  d.video_link != "" ?(
                                                                    <video src={d.video_link} className="uui-w-full uui-h-full w-100" autoplay="" playsinline="" preload="auto"></video>
                                                                ):(
                                                                    <img className="img-responsive-thumb" src={d.image_link} alt={d.stock_num} />
                                                                )}
                                                                <br />
                                                                <span>{d.stock_num}</span>
                                                            </label>
                                                        </div>
                                                        <div className='col-6 col-sm-6 col-md-6 col-lg-6 text-start'>
                                                            {d.diamond_type}-{d.shape}-{d.carat}<br/>
                                                            Color: {d.color} | Clarity: {d.clarity}<br/>
                                                            Cut: {d.Cut} |  Polish: {d.Polish}<br/>
                                                            {!isDiamondPriceHidden(flags) && (<>MSRP: {d.prices}<br/></>)}
                                                            {account !='W284' && d.certificate != 0 & (
                                                                <>
                                                                    Certificate: {d.certificate}
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                        </>
                                    )}
                                    <div className='col-12 col-sm-12 col-md-12 col-lg-12 dp-viewmore-wrap'>
                                        <button className='btn btn-primary dp-viewmore-btn' onClick={handleViewMore} disabled={isFetching} style={{width: 'fit-content'}}>
                                            {isFetching ? 'Loading...' : viewMore ? 'Show Less' : 'View More'}
                                        </button>
                                    </div>
                                </div>
                            ):(
                                <table className="table table-bordered">
                                    <thead>
                                        <tr className='head-color'>
                                            {(!flags?.['HIDE_DIAMOND_COLUMN'] || flags?.['HIDE_DIAMOND_COLUMN'] == 'No') && (
                                                <th>Item Code</th>
                                            )}
                                            <th>Lab/Natural</th>
                                            <th>Shape</th>
                                            <th>Size</th>
                                            <th>Color</th>
                                            <th>Clarity</th>
                                            {(!flags?.['HIDE_DIAMOND_COLUMN'] || flags?.['HIDE_DIAMOND_COLUMN'] == 'No') && (
                                                <th>Cut</th>
                                            )}
                                            {(!flags?.['HIDE_DIAMOND_COLUMN'] || flags?.['HIDE_DIAMOND_COLUMN'] == 'No') && (
                                                <th>Depth%</th>
                                            )}
                                            {(!flags?.['HIDE_DIAMOND_COLUMN'] || flags?.['HIDE_DIAMOND_COLUMN'] == 'No') && (
                                                <th>Table%</th>
                                            )}
                                            <th>Measurements</th>
                                            <th>Cert Lab</th>
                                            <th>Certificate#</th>
                                            {(!flags?.['HIDE_DIAMOND_PRICE'] || flags?.['HIDE_DIAMOND_PRICE'] == 'No') && (
                                                <th>MSRP $</th>
                                            )}
                                            {/* ...other columns */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {diamonds.length > 0 &&  (
                                            <>
                                                {diamonds.map((d, index) => (
                                                    <tr key={index} className={index % 2 === 0 ? 'even-row' : 'odd-row'}>
                                                        {(!flags?.['HIDE_DIAMOND_COLUMN'] || flags?.['HIDE_DIAMOND_COLUMN'] == 'No') && (
                                                            <td><b><a className='hyperLink dp-link-strong' href="#" onClick={(e) => { e.preventDefault(); handleStockClick(d);  }}>{d.stock_num}</a></b></td>
                                                        )}
                                                        <td>{d.diamond_type}</td>
                                                        <td>{d.shape}</td>
                                                        <td>{d.carat}</td>
                                                        <td>{d.color}</td>
                                                        <td>{d.clarity}</td>
                                                        {(!flags?.['HIDE_DIAMOND_COLUMN'] || flags?.['HIDE_DIAMOND_COLUMN'] == 'No') && (
                                                            <td>{d.Cut}</td>
                                                        )}
                                                        {(!flags?.['HIDE_DIAMOND_COLUMN'] || flags?.['HIDE_DIAMOND_COLUMN'] == 'No') && (
                                                            <td>{d.depth}</td>
                                                        )}
                                                        {(!flags?.['HIDE_DIAMOND_COLUMN'] || flags?.['HIDE_DIAMOND_COLUMN'] == 'No') && (
                                                            <td>{d.table}</td>
                                                        )}
                                                        <td>{d.measurement}</td>
                                                        <td>{d.Lab}</td>
                                                        <td><b><a className='hyperLink dp-link-strong' href="#" onClick={(e) => { e.preventDefault(); handleStockClick(d);  }}>{d.certificate}</a></b></td>
                                                        {(!flags?.['HIDE_DIAMOND_PRICE'] || flags?.['HIDE_DIAMOND_PRICE'] == 'No') && (
                                                            <td>{d.prices}</td>
                                                        )}
                                                    </tr>
                                                ))}
                                            </>
                                        )}
                                    </tbody>
                                </table>
                            )}
                            {isFetching && <p> <SpinnerComponent /></p>}
                            {/* end-of-list sentinel — observed by IntersectionObserver to load the next page */}
                            <div ref={loadMoreRef} aria-hidden="true" className="dp-scroll-sentinel" />
                        </div>
                    </div>
                </div>
            </div>
            <div>
                {showModal && (
                    <div className="modal show d-block" tabIndex="-1" role="dialog">
                        <div className="modal-dialog modal-dialog-centered modal-xl dp-modal-dialog" role="document">
                            <div className="modal-content p-0">
                                <DiamondDetailsModal
                                    closeDiamondModal={handleCloseDiamondModal}
                                    closeAllModel={handleAddDiamond}
                                    diamondDetailsTemp={selectedStock}
                                    diamondDetailsPricesTemp={selectedStockPrice}
                                    colorCodes={colorCodes}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
};
export default DiamondListPage;